import NewFeatureSection from "@/pages/registerCompany/NewFeatureSection";
import {type FC, type PropsWithChildren} from "react";
import {useLocation} from "react-router";
import {useMedia} from "react-use";

const AuthLayout: FC<PropsWithChildren> = ({children}) => {
  const {pathname} = useLocation();
  const shouldShowNewFeatureSection = useMedia("(min-width: 1024px)");

  if (["/verify-email/"].some(path => new RegExp(`^/?${path.replace(/^\/|\/$/g, "")}/?$`).test(pathname))) {
    return <>{children}</>;
  }

  return shouldShowNewFeatureSection ? (
    <div className="hidden min-h-[calc(100vh-80px)] lg:grid lg:grid-cols-5">
      <div className="col-span-3 flex h-full flex-col items-center justify-between gap-10 overflow-y-auto px-12 pt-10 pb-7">
        {children}
      </div>
      <NewFeatureSection />
    </div>
  ) : (
    <div className="max-w-8xl container mx-auto flex flex-col items-center gap-10 px-4 pt-10 pb-20 sm:px-8 lg:hidden">
      {children}
    </div>
  );
};

export default AuthLayout;
